import { createClient } from 'contentful'

export default createClient({
  space: '526rfqoj6s37',
  accessToken: 'KL1GvLMay9bsnhNQZr8fE2ZN68ILPbr5pmXyiLvQPmo',
  environment: 'master-updates-2023-04-27'

  // accessToken: 'SWFtB4IaGqyGC95Mg8S-SC3iPisvbcO6vYxpL0jN-S8'
  // space: process.env.VUE_APP_CONTENTFUL_SPACE_ID,
  // accessToken: process.env.VUE_APP_CONTENTFUL_ACCESS_TOKEN
})
